import { Component, OnInit, computed, inject, input, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, QiraUser } from '@app/services/auth.service';
import { PaymentService } from '@app/services/payment.service';
import { ProfileDataComponent } from './profile-data/profile-data.component';
import { ProfileSubscriptionComponent } from './subscription/subscription.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  imports: [TranslocoPipe, ProfileDataComponent, ProfileSubscriptionComponent],
})
export class ProfileComponent implements OnInit {
  // Modal inputs (optional - used when opened in a modal)
  data = input<any>();
  close = input<(() => void) | undefined>();

  route = inject(ActivatedRoute);
  authService = inject(AuthService);
  paymentService = inject(PaymentService);

  userName: string | null = null;
  user: QiraUser | undefined = undefined;
  loading = signal<boolean>(true);

  successMessage = computed(() => this.paymentService.paymentSuccess());
  isPropoints = computed(() => this.user?.company.propoints);

  async ngOnInit() {
    this.userName = this.route.snapshot.paramMap.get('username');
    // This is for later. You could see other people's profiles.
    if (this.userName) {
      this.user = this.authService.currentUser();
      this.loading.set(false);
    } else {
      this.user = this.authService.currentUser();
      this.loading.set(false);
    }
  }

  async onChange(user: QiraUser | undefined) {
    this.user = user;
  }

  async onChangeSubscription(user: QiraUser | undefined) {
    this.user = user;
  }
}
